import api from "@/core/api";

export const signalsApi = {
	async list(idPatient?: string, notifyDateFrom?: string, notifyDateTo?: string) {
		const params: any = {};
		if (idPatient) params.idPatient = idPatient;
		if (notifyDateFrom) params.notifyDateFrom = notifyDateFrom;
		if (notifyDateTo) params.notifyDateTo = notifyDateTo;

		const queryString = new URLSearchParams(params).toString();
		const url = `/signals${queryString ? `?${queryString}` : ''}`;
		
		return await api.query(url, { method: 'get' });
	},

	async getByPatientAndField(idPatient: string, fieldName: string) {
		return await api.query(`/signals/by-patient-field/${idPatient}/${fieldName}`, { method: 'get' });
	},

	async create(idPatient: string, tableName: string, fieldName: string, fieldValue: string, notifyDate: Date, description: string) {
		return await api.query('/signals', {
			method: 'post',
			data: {
				id_patient: idPatient,
				table_name: tableName,
				field_name: fieldName,
				field_value: fieldValue,
				notify_date: notifyDate.toISOString(),
				description
			}
		});
	},

	async update(id: string, notifyDate: Date, description: string, isCompleted: boolean = false) {
		return await api.query(`/signals/${id}`, {
			method: 'put',
			data: {
				notify_date: notifyDate.toISOString(),
				description,
				is_completed: isCompleted
			}
		});
	},

	async delete(id: string) {
		return await api.query(`/signals/${id}`, { method: 'delete' });
	},

	async getActiveCount() {
		const result: any = await api.query('/signals/active-count', { method: 'get' });
		return result?.count || 0;
	}
};

